export { default } from './ExecDescBlock';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/ExecDescBlock/index.js